export const charCopy = (charLength: number): string => {
  if (charLength === 1) {
    return "znak";
  } else if (charLength > 1 && charLength < 5) {
    return "znaki";
  } else {
    return "znaków";
  }
};
